import FnrFetch3, { callMockResponse } from "Utilities/FnrFetch/FnrFetch3";
import { fnThrowError } from "Utilities/fnReportError";

import { mockData } from "./mockData";

export const getHomeSettings = async () => {
  const endpoint = `/homeSettings`;

  const fetchFunction = mockData.shouldMock
    ? callMockResponse(mockData.getHomeSettings)
    : new FnrFetch3(endpoint);

  const response = await fetchFunction.get().catch((err) =>
    fnThrowError({
      message: `Error at ${endpoint}: ${err.message || err}`,
    })
  );

  return response;
};

export const patchHomeSettings = async (data) => {
  const endpoint = `/homeSettings`;
  const fetchFunction = new FnrFetch3(endpoint, data);

  const response = await fetchFunction.patch().catch((err) => {
    throw new Error(err.message || err);
  });

  return response;
};

export const createCroppedPhoto = async (settings) => {
  const endpoint = `/image/croppedPhoto`;
  const fetchFunction = new FnrFetch3(endpoint, settings);

  const response = await fetchFunction.post().catch((err) => {
    throw new Error(err.message || err);
  });
  return response;
};

export const updateCroppedPhoto = async (croppedPhotoID, settings) => {
  // /image/croppedPhoto ? croppedPhotoID = 1234
  const endpoint = `/image/croppedPhoto?croppedPhotoID=${croppedPhotoID}`;
  const fetchFunction = new FnrFetch3(endpoint, settings);

  const response = await fetchFunction.patch().catch((err) => {
    throw new Error(err.message || err);
  });

  return response;
};

export const uploadPhoto = async (formData, options) => {
  const endpoint = `/upload/photo/misc`;

  const fetchFunction = new FnrFetch3(endpoint, formData, options);

  const response = await fetchFunction.post().catch((err) =>
    fnThrowError({
      message: err.error ?? `Error at ${endpoint}: ${err}`,
    })
  );

  return response;
};

export const getMyNotes = async (cursor = "", searchTerm = "") => {
  // const cursorParam = cursor ? encodeURIComponent(`cursor=${cursor}`) : "";
  // const searchTermParam = searchTerm ? encodeURIComponent(`&searchTerm=${searchTerm}`) : "";
  const encodedSearchTerm = encodeURIComponent(searchTerm);
  const endpoint = `/home/api/mynotes?cursor=${cursor}&searchTerm=${encodedSearchTerm}`;
  const fetchFunction = new FnrFetch3(endpoint);
  const response = await fetchFunction.get().catch((err) => {
    throw new Error(err.message || err);
  });

  return response;
};

// -------------------------------------------------------------
// Code for fetching notes page html and assets -- might scrap later
// -------------------------------------------------------------

// export const getNote = async (noteId) => {
//   const endpoint = `/note/${noteId}`;
//   const response = await fetch(endpoint).catch((err) => {
//     throw new Error(err.message || err);
//   });

//   if (!response.ok) {
//     throw new Error(`HTTP error! status: ${response.status}`);
//   }

//   const text = await response.text();
//   console.log("text", text);
//   return text;
// };

// export const getNoteComments = async (noteId) => {
//   const endpoint = `/comment/${noteId}/getComments`;
//   const response = await fetch(endpoint).catch((err) => {
//     throw new Error(err.message || err);
//   });

//   console.log("response", response);

//   return response;
// };
